export const EST_CEL = 'est_cel'; //estat del cel
export const TEMP = 'temp'; // temperatura
export const TEMP_MAX = 'temp_max'; // temperatura màxima
export const TEMP_MIN = 'temp_min'; // temperatura mínima
export const TEMP_XAF = 'temp_xaf'; // temperatura de xafogor
export const PREC_ACU = 'prec_acu'; // precipitacio acumulada
export const PROB_PREC = 'prob_prec'; // probabilitat de precipitació
export const HUM_REL = 'hum_rel'; // humitat relativa
export const VENT_DIR = 'vent_dir'; // direccio del vent
export const VENT_VELO = 'vent_velo'; // velocitat del vent



// WEBPACK FOOTER //
// ./src/utils/variables.js